import * as React from 'react';

import { View } from '@longline/aqua-ui/controls/View';
import { PrimaryButton } from '@longline/aqua-ui/controls/PrimaryButton';

import { useAuth } from '../../contexts/auth/useAuth';
import { Pane } from '../../ui/Pane';
import { useAccountContext } from './IAccountContext';
import { SecondaryButton } from '@longline/aqua-ui/controls/SecondaryButton';
import { SVG } from '@longline/aqua-ui/svg';
import { CountryFormatter } from '@longline/aqua-ui/formatters/CountryFormatter';
import { useGlobalState } from '../../contexts/state/GlobalStateContext';

const ViewProfile = () => {
  const auth = useAuth();
  const globalState = useGlobalState();
  const ctx = useAccountContext();

  const doSignout = () => {
    globalState.setMode(null);
    auth.signout();
  }

  const signoutAction = <SecondaryButton negative title="Sign out" icon={SVG.Menu.Signout} onClick={doSignout}/>

  return (
    <>
      <Pane.Heading>
        <Pane.Title>Account</Pane.Title>
      </Pane.Heading>
      <Pane.Subheader expandable action={signoutAction}>
        Sign out
      </Pane.Subheader>

      <Pane.Body>
        <View label="Email" hint="Email address">
          {auth.user?.email}
        </View>
        <View label="Name" hint="Name">
          {auth.user?.name}
        </View>
        <View label="Country" hint="Home country">
          <CountryFormatter type='both' value={auth.user?.country ?? ""}/>
        </View>
        <View label="Phone number" hint="Mobile number for SMS login">
          {auth.user?.phoneNumber || '—'}
        </View>
      </Pane.Body>
      <Pane.Footer>
        <PrimaryButton onClick={() => ctx.setMode('edit')}>EDIT PROFILE</PrimaryButton>
        <PrimaryButton onClick={() => ctx.setMode('password')}>CHANGE PASSWORD</PrimaryButton>
      </Pane.Footer>
    </>
  );
}

export { ViewProfile }

